import React from "react";
import { Button, Form, Row, Col, Table, Spin } from "antd";
import { CommonMasterSelect } from "../Components/CommonMasterSelect";
import { useAuth } from "../Auth/Auth";
import { http } from "../Common/http";
import { ColumnType } from "antd/lib/table";
import { AllocationUser } from "./AllocationButton";

interface Props {
  existedUsers?: AllocationUser[];
  onChange?: (selectUsers: AllocationUser[]) => void;
}
interface PostSearchData {
  FacultyId?: string;
  DepartmentId?: string;
  MajorId?: string;
  CourceId?: string;
}

// const pageSize = 5;

export const AllocationUserSearchPage = ({ existedUsers, onChange }: Props) => {
  const { accessToken } = useAuth();
  const [isLoading, setIsLoading] = React.useState(false);
  const [datas, setDatas] = React.useState<AllocationUser[]>([]);
  const [faculty, setFaculty] = React.useState("");
  const [department, setDepartment] = React.useState("");
  const [major, setMajor] = React.useState("");
  const [selectedRowKeys, setSelectedRowKeys] = React.useState<string[]>([]);

  const initData = async () => {
    // try {
    //   const result = await http<JustmentUnitData>({
    //     path: "/Master/getjustmentunit/" + value,
    //     method: "get",
    //     accessToken: accessToken,
    //   });
    //   if (result.ok && result.body) {
    //     setDatas([result.body]);
    //     onDataChange(result.body, false);
    //   }
    // } catch (error) {
    //   console.log(error);
    // }
  };

  React.useEffect(() => {
    initData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const columns: ColumnType<AllocationUser>[] = [
    {
      title: <div className="table-title">学部</div>,
      dataIndex: "facultyName",
      key: "facultyName",
    },
    {
      title: <div className="table-title">学科</div>,
      dataIndex: "departmentName",
      key: "departmentName",
    },
    {
      title: <div className="table-title">専攻</div>,
      dataIndex: "majorName",
      key: "majorName",
    },
    {
      title: <div className="table-title">コース</div>,
      dataIndex: "courceName",
      key: "courceName",
    },
    {
      title: <div className="table-title">教員名前</div>,
      key: "name",
      render: (value: any, item: AllocationUser, index: number) =>
        `${item.sei} ${item.mei}`,
    },
  ];

  // 採点担当候補者変更ボタン押す
  const onDataSelect = () => {
    const values: AllocationUser[] = [];
    if (selectedRowKeys.length > 0) {
      for (let i = 0; i < selectedRowKeys.length; i++) {
        for (let j = 0; j < datas.length; j++) {
          if (selectedRowKeys[i] === datas[j].userId) {
            values.push(datas[j]);
            break;
          }
        }
      }
    }
    setSelectedRowKeys([]);
    setDatas([]);
    onChange!(values);
  };

  // 一覧のチェックボックスのチェック・クリア
  const onSelectChange = (selectedRowKeys: any) => {
    setSelectedRowKeys(selectedRowKeys);
  };

  // 検索ボタン押す
  const onFinish = async (values: any) => {
    // console.log("Success:", values);
    try {
      setIsLoading(true);
      const searchData: PostSearchData = {
        FacultyId: values.faculty ? values.faculty.value : null,
        DepartmentId: values.department ? values.department.value : null,
        MajorId: values.major ? values.major.value : null,
        CourceId: values.course ? values.course.value : null,
      };
      const result = await http<AllocationUser[], PostSearchData>({
        path: "/User/searchgrader",
        method: "post",
        body: searchData,
        accessToken: accessToken,
      });
      if (result.ok && result.body) {
        const initSelectedRowKeys: string[] = [];
        if (
          result.body.length > 0 &&
          existedUsers !== undefined &&
          existedUsers?.length > 0
        ) {
          for (let i = 0; i < result.body.length; i++) {
            for (let j = 0; j < existedUsers.length; j++) {
              if (result.body[i].userId === existedUsers[j].userId) {
                initSelectedRowKeys.push(result.body[i].userId);
                break;
              }
            }
          }
        }
        setSelectedRowKeys(initSelectedRowKeys);
        setDatas(result.body);
        setIsLoading(false);
      } else {
        setIsLoading(false);
      }
    } catch (error) {
      console.log(error);
      setIsLoading(false);
    }
  };
  return (
    <Spin spinning={isLoading}>
      <div>
        <Form
          colon={false}
          labelCol={{ span: 4 }}
          layout="horizontal"
          labelAlign="left"
          name="userSearchForm"
          onFinish={onFinish}
        >
          <Row style={{ width: "100%", marginBottom: "10px" }}>
            <Col span={8}>
              <Form.Item label="学部" name="faculty">
                <CommonMasterSelect
                  masterType={2}
                  width={160}
                  onChange={(item: any) => {
                    setFaculty(item ? item.value : "");
                  }}
                />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item label="学科" name="department">
                <CommonMasterSelect
                  masterType={3}
                  width={160}
                  fid={faculty}
                  onChange={(item: any) => {
                    setDepartment(item ? item.value : "");
                  }}
                />
              </Form.Item>
            </Col>
          </Row>
          <Row style={{ width: "100%", marginBottom: "10px" }}>
            <Col span={8}>
              <Form.Item label="専攻" name="major">
                <CommonMasterSelect
                  masterType={4}
                  width={160}
                  fid={department}
                  onChange={(item: any) => {
                    setMajor(item ? item.value : "");
                  }}
                />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item label="コース" name="course">
                <CommonMasterSelect masterType={5} width={160} fid={major} />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item>
                <Button type="primary" htmlType="submit">
                  検索
                </Button>
              </Form.Item>
            </Col>
          </Row>
        </Form>

        <Row style={{ width: "100%" }}>
          <Col span={24}>
            <Table
              bordered
              size={"small"}
              loading={isLoading}
              rowKey={(record) => record.userId}
              columns={columns}
              dataSource={datas}
              rowSelection={{
                selectedRowKeys,
                type: "checkbox",
                onChange: onSelectChange,
              }}
              pagination={{
                size: "small",
                // pageSize: pageSize,
                position: ["topLeft"],
                showTotal: (total) => {
                  return (
                    <ul className="resultCount">
                      <li className="grey">
                        対象<span>{total}</span>
                      </li>
                    </ul>
                  );
                },
                // onChange: (current) => setPage(current),
              }}
              // scroll={{ y: 720 }}
            />
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <Button
              type="primary"
              style={{
                float: "right",
                marginRight: "20px",
                marginTop: "10px",
              }}
              onClick={onDataSelect}
            >
              採点担当候補者変更
            </Button>
          </Col>
        </Row>
      </div>
    </Spin>
  );
};
